// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status[data-v-5574f322] {\n  margin-top: 15px;\n  position: relative;\n  left: -33px;\n  color: white;\n  text-align: center;\n}\n.status.status-custom[data-v-5574f322] {\n  left: -53px;\n}\n.wrapper-object[data-v-5574f322] {\n  width: 200px;\n}", ""]);
// Exports
module.exports = exports;
